import * as v from "valibot";
import { baseVals, defineRecordSchema, defineValidation } from "../../common/validation.common";
import { OLTTypeEnum } from "../../data/enums";

export namespace NetworkOLTValidation {
    export const Record = defineValidation(
        defineRecordSchema({
            filters: v.object({
                type: v.optional(v.picklist(OLTTypeEnum.values)),
            }),
        }),
    );

    export const Create = defineValidation(
        v.object({
            name: baseVals.string(),
            host: baseVals.ipv4(),
            port: v.optional(baseVals.intRange(1, 65535, "Port")),
            username: baseVals.string(),
            password: baseVals.string(),
        }),
    );

    export const Update = defineValidation(
        v.object({
            name: v.exactOptional(baseVals.string()),
            host: v.exactOptional(baseVals.ipv4()),
            port: v.exactOptional(baseVals.intRange(1, 65535, "Port")),
            username: v.exactOptional(baseVals.string()),
            password: v.exactOptional(baseVals.string()),
        }),
    );

    export const ObtainFrame = defineValidation(
        v.object({
            id: v.number(),
        }),
    );

    export const ToggleDLPortAutofind = defineValidation(
        v.object({
            f: v.number(),
            s: v.number(),
            p: v.number(),
            status: v.picklist(["enable", "disable"]),
        }),
    );

    export const ObtainDBAProfile = defineValidation(
        v.object({
            id: v.number(),
        }),
    );

    export const CreateDBAProfile = defineValidation(
        v.object({
            name: v.optional(v.string()),
            desc: v.optional(v.string()),
            type: v.picklist(["type1", "type2", "type3", "type4", "type5"]),
            assureKbps: v.number(),
            fixKbps: v.number(),
            maxKbps: v.number(),
        }),
    );

    export const DeleteDBAProfile = defineValidation(
        v.object({
            id: v.number(),
        }),
    );

    export const ObtainSRVProfile = defineValidation(
        v.object({
            id: v.number(),
        }),
    );

    export const CreateSRVProfile = defineValidation(
        v.object({
            name: v.optional(v.string()),
        }),
    );

    export const DeleteSRVProfile = defineValidation(
        v.object({
            id: v.number(),
        }),
    );

    export const ObtainLineProfile = defineValidation(
        v.object({
            id: v.number(),
        }),
    );

    export const CreateLineProfile = defineValidation(
        v.object({
            name: v.optional(v.string()),
        }),
    );

    export const DeleteLineProfile = defineValidation(
        v.object({
            id: v.number(),
        }),
    );

    export const ObtainTR069Profile = defineValidation(
        v.object({
            id: v.number(),
        }),
    );

    export const CreateTR069Profile = defineValidation(
        v.object({
            url: v.pipe(v.string(), v.url()),
            name: v.optional(v.string()),
            username: v.optional(v.string()),
            password: v.optional(v.string()),
        }),
    );

    export const DeleteTR069Profile = defineValidation(
        v.object({
            id: v.number(),
        }),
    );

    export const ObtainVLAN = defineValidation(
        v.object({
            id: v.number(),
        }),
    );

    export const CreateVLAN = defineValidation(
        v.object({
            id: v.pipe(v.number(), v.minValue(1), v.maxValue(4080)),
            desc: v.optional(v.string()),
        }),
    );

    export const UpdateVLANAttachPort = defineValidation(
        v.object({
            f: v.number(),
            s: v.number(),
            p: v.number(),
            vlanId: v.number(),
        }),
    );

    export const UpdateVLANDetachPort = defineValidation(
        v.object({
            f: v.number(),
            s: v.number(),
            p: v.number(),
            vlanId: v.number(),
        }),
    );

    export const DeleteVLAN = defineValidation(
        v.object({
            id: v.number(),
        }),
    );

    export const ObtainONT = defineValidation(
        v.object({
            f: v.number(),
            s: v.number(),
            p: v.number(),
            id: v.number(),
        }),
    );

    export const CreateONT = defineValidation(
        v.object({
            f: v.number(),
            s: v.number(),
            p: v.number(),
            sn: v.string(),
        }),
    );

    export const UpdateONT = defineValidation(
        v.object({
            f: v.number(),
            s: v.number(),
            p: v.number(),
            id: v.number(),
            desc: v.string(),
        }),
    );

    export const UpdateONTAttachVLAN = defineValidation(
        v.object({
            f: v.number(),
            s: v.number(),
            p: v.number(),
            id: v.number(),
            vlanId: v.number(),
        }),
    );

    export const UpdateONTDetachVLAN = defineValidation(
        v.object({
            f: v.number(),
            s: v.number(),
            p: v.number(),
            id: v.number(),
            vlanId: v.number(),
        }),
    );

    export const UpdateONTCreateTR069WAN = defineValidation(
        v.object({
            f: v.number(),
            s: v.number(),
            p: v.number(),
            id: v.number(),
            vlanId: v.number(),
        }),
    );

    export const UpdateONTDeleteTR069WAN = defineValidation(
        v.object({
            f: v.number(),
            s: v.number(),
            p: v.number(),
            id: v.number(),
        }),
    );

    export const DeleteONT = defineValidation(
        v.object({
            f: v.number(),
            s: v.number(),
            p: v.number(),
            id: v.number(),
        }),
    );

    export const RebootONT = defineValidation(
        v.object({
            f: v.number(),
            s: v.number(),
            p: v.number(),
            id: v.number(),
        }),
    );
}
